const LABEL = /^(summary|overview|purpose|objective|scope|steps|procedure|process)\s*[:\-–—]?\s*(.*)$/i;
const ITEM = /^(?:(?:\d+|[a-zA-Z])[.)]|step\s+\d+\s*[:.\-–—]|[-*•●▪◦–])\s+(.*)$/i;
const SECTION = { summary: "summary", overview: "summary", purpose: "purpose", objective: "purpose", scope: "purpose", steps: "steps", procedure: "steps", process: "steps" };

export function htmlToText(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const out = [];
  const walk = (node, list) => {
    for (const el of node.childNodes) {
      if (el.nodeType === 3) { out.push(el.textContent); continue; }
      if (el.nodeType !== 1 || ["STYLE", "SCRIPT", "META"].includes(el.tagName)) continue;
      const tag = el.tagName;
      if (tag === "BR") { out.push("\n"); continue; }
      if (tag === "OL" || tag === "UL") { out.push("\n"); walk(el, { ordered: tag === "OL", n: Number(el.getAttribute("start") || 1) }); out.push("\n"); continue; }
      if (tag === "LI") {
        const has = /^\s*(\d+[.)]|[-*•])\s/.test(el.textContent);
        out.push("\n" + (has || !list ? "" : list.ordered ? `${list.n++}. ` : "- "));
        walk(el, null);
        out.push("\n");
        continue;
      }
      const block = /^(P|DIV|H[1-6]|TR|SECTION|ARTICLE|BLOCKQUOTE)$/.test(tag);
      if (block) out.push("\n");
      walk(el, list);
      if (block) out.push("\n");
    }
  };
  walk(doc.body, null);
  return out.join("").replace(/\u00a0/g, " ").replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}

export function parseHandbook(raw) {
  const lines = raw.replace(/\r\n?/g, "\n").replace(/\u00a0/g, " ").split("\n").map((l) => l.trim());
  let i = 0;
  while (i < lines.length && !lines[i]) i++;
  const title = (lines[i] || "").replace(/^#+\s*/, "");
  const res = { title, summary: [], purpose: [], steps: [] };
  const hasList = lines.slice(i + 1).some((l) => ITEM.test(l));
  let section = hasList ? "summary" : "steps";
  let step = null;
  let paraBreak = true;
  for (const line of lines.slice(i + 1)) {
    if (!line) { paraBreak = true; if (section === "steps" && !hasList) step = null; continue; }
    const lab = line.match(LABEL);
    if (lab && (lab[2] === "" || /[:\-–—]/.test(line.slice(lab[1].length, lab[1].length + 3)))) {
      section = SECTION[lab[1].toLowerCase()];
      step = null;
      if (lab[2]) section === "steps" ? res.steps.push((step = { title: lab[2], detail: "" })) : res[section].push(lab[2]);
      continue;
    }
    const item = line.match(ITEM);
    if (item) { section = "steps"; res.steps.push((step = { title: item[1], detail: "" })); paraBreak = false; continue; }
    if (section === "steps") {
      if (step && !(paraBreak && !hasList)) step.detail = step.detail ? `${step.detail}\n${line}` : line;
      else res.steps.push((step = { title: line, detail: "" }));
    } else res[section].push(line);
    paraBreak = false;
  }
  return { title: res.title, summary: res.summary.join("\n"), purpose: res.purpose.join("\n"), steps: res.steps };
}

const words = (s) => (s || "").split(/\s+/).filter(Boolean);

export function sourceWords(raw) {
  return raw.replace(/\r\n?/g, "\n").replace(/\u00a0/g, " ").split("\n").map((l) => l.trim()).filter(Boolean).flatMap((l, idx) => {
    let t = idx === 0 ? l.replace(/^#+\s*/, "") : l;
    const lab = t.match(LABEL);
    if (idx > 0 && lab && (lab[2] === "" || /[:\-–—]/.test(t.slice(lab[1].length, lab[1].length + 3)))) t = lab[2];
    const item = t.match(ITEM);
    if (item) t = item[1];
    return words(t);
  });
}

export function sameWords(raw, parsed) {
  const a = sourceWords(raw).sort().join(" ");
  const b = [parsed.title, parsed.summary, parsed.purpose, ...parsed.steps.flatMap((s) => [s.title, s.detail])].flatMap(words).sort().join(" ");
  return a === b;
}
